// extracted by mini-css-extract-plugin
module.exports = {"slide":"TabNotification_slide_342mP","slide-reverse":"TabNotification_slide-reverse_FTH93","notification":"TabNotification_notification_8MUSc"};